<div class="form form--height form--full-width" [ngClass]="getLevelClass()">
  <div class="form__label">
    <basic-label [noIndent]="true"></basic-label>
  </div>

  <div class="form__inline-field-container form__inline-field-container--half-width">
    <div class="form__field">
      <basic-text-input [propertyName]="heightFeetProperty" [placeholder]="'Feet'"></basic-text-input>
    </div>
    <div class="form__field">
      <basic-text-input [propertyName]="heightInchesProperty" [placeholder]="'Inches'"></basic-text-input>
    </div>
  </div>
</div>
